import "./ScoreBarLinear.css"
function ScoreBarLinear({ score, color}) {
    return (
        <div className="score-bar-container">
            <div
                className="score-bar-fill"
                style={{
                    width: `${score}%`,
                    background: `linear-gradient(90deg, var(--main), ${color})`
                }}
            ></div>
        </div>
    );
} export default ScoreBarLinear;